import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { useParams } from 'react-router-dom';
import SaidaVisualizar from '../components/saida/SaidaVisualizar';

const SaidaVisualizarPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography
          variant="h4"
          component="h1"
          gutterBottom
          sx={{
            fontWeight: 'bold',
            fontFamily: 'Arial, sans-serif',
            fontSize: '2.125rem',
            lineHeight: 1.235,
          }}
        >
          Visualizar Nota de Saída
        </Typography>
      </Box>
      {id && <SaidaVisualizar id={Number(id)} />}
    </Container>
  );
};

export default SaidaVisualizarPage;
